import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Wall() {
  const [wall, setWall] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/wall`)
      .then((res) => setWall(res.data))
      .catch(() => setWall({ visible: false, entries: [] }));
  }, []);

  if (!wall || !wall.visible) return null;

  return (
    <section data-testid="the-wall-section" className="py-28 md:py-36 px-4 sm:px-6 bg-secondary/20 border-t border-border">
      <div className="max-w-6xl mx-auto">
        <p className="font-mono text-xs tracking-[0.35em] text-gold mb-6">07 — THE WALL</p>
        <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-light tracking-tight mb-4">
          In their own words.
        </h2>
        <p className="text-muted-foreground mb-16 max-w-xl">
          Anonymous answers from founding members, shared with permission.
        </p>
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 [&>*]:mb-6">
          {wall.entries.map((e, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.1 }}
              className="break-inside-avoid border border-border bg-card/60 p-8"
              data-testid={`wall-entry-${i}`}
            >
              <blockquote className="font-serif text-xl font-light leading-snug text-bone/90 mb-6">
                &ldquo;{e.text}&rdquo;
              </blockquote>
              <figcaption className="font-mono text-[11px] tracking-[0.2em] text-gold">
                HEAVIEST HAT: {e.hat_label.toUpperCase()}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
